import { Component, EventEmitter, Output } from '@angular/core';
import {
  ModalContinueActionButton,
  MODAL_CONTINUE_ACTIONS,
  MODAL_OVERLAY_TYPE,
} from '@models/modal-overlay.class';

@Component({
  selector: 'hb-upgrade-modal',
  templateUrl: './upgrade-modal.component.html',
  styleUrls: ['./upgrade-modal.component.scss'],
})
export class UpgradeModalComponent {
  @Output() upgradeModalActionEmitter: EventEmitter<MODAL_CONTINUE_ACTIONS> =
    new EventEmitter();
  public actionButtons: Array<ModalContinueActionButton> = [
    {
      type: MODAL_CONTINUE_ACTIONS.cancel,
      title: 'Cancelar',
    },
    {
      type: MODAL_CONTINUE_ACTIONS.continue,
      title: 'Continuar',
    },
  ];

  public modalOverlayType = MODAL_OVERLAY_TYPE;

  constructor() {}

  public handleModalButtons(type: MODAL_CONTINUE_ACTIONS): void {
    this.upgradeModalActionEmitter.emit(type);
  }
}
